import { flow, types } from 'mobx-state-tree'
import { downloadInvoiceReq } from '../../network/downloadInvoiceReq'
import { extendAppSessionAPI } from '../../network/extendAppSession'
import { extendUserSessionAPI } from '../../network/extendUserSession'
import { getInvoices } from '../../network/getInvoices'
import { mimeTypes } from '../static/data'
import { customError } from '../static/strings'
import { RootStore } from '../store'
import { Invoice } from './Invoice'

const Invoices = types
  .model('Invoice', {
    invoices: types.optional(types.array(Invoice), []),
  })
  .actions((self) => ({
    getGstInvoices: flow(function* getGstInvoices(year: string, mid: string) {
      let response
      try {
        response = yield getInvoices(mid, year, RootStore.user.session.getTokens)
        self.invoices = response
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),
    downloadInvoice: flow(function* downloadInvoice(mid: string, fileName: string) {
      let errorCode = ''
      let resp
      try {
        resp = yield downloadInvoiceReq(RootStore.user.session.getTokens, mid, fileName)
        // Below is to check the errorcode in the response as its arraybuffer-
        const errorFileResponse = JSON.parse(resp?.data.toString('utf8')) //Buffer.from(resp?.data).toString('utf8')
        errorCode = errorFileResponse?.error?.code

        if (window && errorCode === '' && resp && resp?.data) {
          let contentType = resp.headers['content-type']
          if (mimeTypes.get(contentType) === undefined) {
            return
          } else {
            const blob = new Blob([resp?.data], { type: contentType })
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            document.body.appendChild(a)
            a.href = url
            a.download = `${fileName}${mimeTypes.get(contentType)}`
            a.click()
            window.URL.revokeObjectURL(url)
            document.body.removeChild(a)
          }
        }
      } catch (e) {
        console.log({ e })
      }
      return resp
    }),
  }))
  .views((self) => ({
    getInvoices(year: string): any {
      return self.invoices.filter((item) => item.year === year)
    },
    getYears(): any {
      const key = 'value'
      const parsedyears = self?.invoices.map((item) => {
        return {
          id: item.file,
          value: item.year,
        }
      })
      return parsedyears.reduce((arr, item) => {
        const removed = arr.filter((i) => i[key] !== item[key])
        return [...removed, item]
      }, [])
    },
  }))

const InvoicesData = Invoices.create({
  invoices: [],
})

export { Invoices, InvoicesData }
